import { useModal } from 'common/hooks/use-modal/use-modal.hook';
import { ICitationRead } from 'common/services/citation-service/citation.service.types';
import { notification } from 'common/utils/notification';

export const useCitationModals = (citation: ICitationRead | null | undefined, onCitationChanged: () => void | Promise<void>) => {
  const moveCitationModal = useModal({
    onBeforeShow: (setModalInitData) => {
      if (!citation) {
        return;
      }

      setModalInitData({ citationId: citation.id });
    },
    onClose: (isSuccess) => {
      if (!isSuccess) {
        return;
      }

      void onCitationChanged();
      notification.success({ message: 'Citation was successfully moved.', duration: 5 });
    },
  });

  const editCitationModal = useModal({
    onBeforeShow: (setModalInitData) => {
      if (!citation) {
        return;
      }

      setModalInitData({
        citationId: citation.id,
        licenseNumber: citation.licensePlate,
        licenseState: citation.licenseState,
        ownerType: citation.ownerType,
      });
    },
    onClose: (isSuccess) => {
      if (!isSuccess) {
        return;
      }

      void onCitationChanged();
      notification.success({ message: 'Citation was successfully updated.', duration: 5 });
    },
  });

  return { moveCitationModal, editCitationModal };
};
